// Module
var code = "<a ng-click=\"$event.stopPropagation()\" ga-track-event=\"{{helpLink.trackBy}}\" href=\"{{helpLink.url | translate}}\" target=\"_blank\"> <i class=\"sb-help_link__icon mdi mdi-help-circle-outline\"></i> <md-tooltip md-direction=\"top\">{{ 'GO_TO_TUTORIAL_ACTION' | translate }}</md-tooltip> </a> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbHelpLink/sb_help_link.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;